import React from 'react';
import './InstagramFeed.css';

function InstagramFeed() {
  return (
    <div className="instagram-feed-content">
      <h2 className="section-title">Instagram Feed</h2>
      <p className="section-subtitle">
        Follow us on Instagram for the latest updates and glimpses
      </p>

      <div className="feed-placeholder">
        {/*
          To integrate Instagram, you can embed individual posts using Instagram's embed code feature.
          Alternatively, a third-party widget (like LightWidget, SnapWidget, or EmbedSocial) can be used for a dynamic feed.
          These usually require signing up for a service and pasting their provided embed code here.
        */}

        <p>Instagram Feed Placeholder</p>

        <a
          href="https://www.instagram.com/vaikuntadhama/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
        >
          Visit Vaikuntadhama on Instagram
        </a>
      </div>
    </div>
  );
}

export default InstagramFeed;